module.exports = __webpack_public_path__ + "img/8.b94c3d0a.png";